import * as React from 'react'
import { inject, observer, Provider } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { AppMainView, AppView, AppViewWrapper } from '../../../../components/AppView'
import AppHeader from '../../../../components/AppView/Header'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { Sidebar, SidebarContent } from '../../../../components/AppView/Sidebar'
import { ReportNavigation } from './ReportNavigation'
import { ReportFilterStore } from './ReportFilterStore'
import { NoPermissionsResult } from '../../../../components/NoPermissionsResult'
import './styles.scss'
import { HelpLinkMenu } from '../../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import { PermissionNames } from '@getgreenline/homi-shared'
import { Location } from 'history'
import { AdvancedReportRoutes } from '../../../../constants/Routes'
import { HelpLinks } from '../../../../constants/ExternalLinks'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  currentUserStore: CurrentUserStore
  location: Location
}

interface State {
  reportFilterStore: ReportFilterStore
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class ReportView extends React.Component<React.PropsWithChildren<Props>, State> {
  constructor(props: React.PropsWithChildren<Props>) {
    super(props)

    // Get permitted locations
    const locations = props.currentCompanyStore!.locations!
    const userPermittedLocations = locations.filter((location) =>
      props.currentUserStore!.hasPermissionAtEntity(PermissionNames.CAN_VIEW_REPORTS, location.id),
    )
    if (props.currentCompanyStore.company?.id) {
      const reportFilterStore = new ReportFilterStore(
        props.currentCompanyStore.company.id,
        props.location,
        userPermittedLocations.map((l) => l.id),
      )

      this.state = {
        reportFilterStore: reportFilterStore,
      }
    }
  }

  render() {
    const company = this.props.currentCompanyStore!.company!

    if (
      !this.props.currentUserStore!.hasPermissionAtEntity(
        PermissionNames.CAN_VIEW_REPORTS,
        company.id,
      )
    ) {
      return <NoPermissionsResult permissionName={PermissionNames.CAN_VIEW_REPORTS} />
    }

    const { reportFilterStore } = this.state

    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child as any, {
        companyId: company.id,
        startDate: reportFilterStore.startDate,
        endDate: reportFilterStore.endDate,
        locationIds: reportFilterStore.permittedLocationIds,
      })
    })

    const isAdvancedSummaryReport = this.props.location.pathname.includes(
      AdvancedReportRoutes.SALES_SUMMARY,
    )
    return (
      <AppView>
        <Sidebar>
          <SidebarContent>
            <ReportNavigation location={this.props.location} />
          </SidebarContent>
        </Sidebar>
        <AppViewWrapper>
          <AppHeader title='Reports'>
            <HelpLinkMenu
              helpLinkMenus={{
                href: HelpLinks.REPORTS_TERMINOLOGY,
                title: 'Financial reports',
              }}
            />
          </AppHeader>
          <AppMainView
            className='background-grey'
            style={isAdvancedSummaryReport ? { overflowX: 'scroll' } : undefined}
          >
            <Provider reportFilterStore={reportFilterStore}>
              <div style={{ minHeight: '80vh', marginBottom: 70 }}>
                {reportFilterStore.isLoading ? <span /> : children}
              </div>
            </Provider>
          </AppMainView>
        </AppViewWrapper>
      </AppView>
    )
  }
}
